import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ToastService } from '../services/toast.service';

/**
 * Blocks app shells until the signed-in account is "ready":
 *  - operators created with a temporary password must set a new one
 *  - when platform-wide operator 2FA is required, the operator must enable it
 * Runs after authGuard.
 */
export const accountGateGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const toast = inject(ToastService);
  return auth.loadUser().pipe(
    map(() => {
      if (auth.mustChangePassword() && !state.url.startsWith('/change-password')) {
        return router.createUrlTree(['/change-password']);
      }
      if (auth.operator2faRequired()) {
        // Operators set up 2FA on their own account page; workspace users on /profile.
        const target = auth.isOperator() ? '/operator/account' : '/profile';
        if (!state.url.startsWith(target)) {
          toast.info('Two-step verification is required for operator accounts. Enable it here to continue.');
          return router.createUrlTree([target], auth.isOperator() ? {} : { queryParams: { require2fa: '1' } });
        }
      }
      return true;
    }),
  );
};
